<template>
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M34.9997 64.1666C51.108 64.1666 64.1663 51.1082 64.1663 34.9999C64.1663 18.8916 51.108 5.83325 34.9997 5.83325C18.8914 5.83325 5.83301 18.8916 5.83301 34.9999C5.83301 51.1082 18.8914 64.1666 34.9997 64.1666Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M23.333 35H46.6663" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M35 23.3334V46.6667" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
